import { useState, useEffect, useCallback } from "react";
import APIutil from "../../../../../api/APIutils";
import * as url from "../../../../../api/url"
import moment from "moment";

export const useFetchSecureConnectedDevices = ({ secureNetworkId }) => {
    const [state, setState] = useState({
        data: [],
        loading: false,
        error: false,
        errorMessage: ""
    });

    useEffect(() => {
        fetchData();
    }, []);

    const timeZoneAbbreviated = (datestring) => {
        const { 1: tz } = new Date(datestring).toString().match(/\((.+)\)/);
        if (tz.includes(" ")) {
          return tz
            .split(" ")
            .map(([first]) => first)
            .join("");
        } else {
          return tz;
        }
      };

    const fetchData = useCallback((suppressError) => {
        setState(prevState => ({ ...prevState, loading: true }));
        APIutil.getDataAPI(url.get_NetworkDetailList + "/" + secureNetworkId).then(response => {
            if (response && Array.isArray(response)) {
                const updatedResponse = JSON.parse(JSON.stringify(response));
                updatedResponse.map(rowData => {
                    const timeZone = timeZoneAbbreviated(rowData.lastConnectedDate);
                    rowData["lastConnectedDate"] = `${moment(rowData.lastConnectedDate).format("MMM/DD/YYYY h:mm A")} ${timeZone}`;
                    return rowData;
                });
                setState(prevState => ({ ...prevState, loading: false, data: updatedResponse, error: false, errorMessage: "" }));
            } else {
                const message = response && response.statusText ? response.statusText : "Something went wrong. Please try refreshing the page."
                if (suppressError) {
                    setState(prevState => ({ ...prevState, loading: false }));
                } else {
                    setState(prevState => ({ ...prevState, loading: false, error:true, errorMessage: message }));
                }
            }
        }).catch(error => {
            if (suppressError) {
                setState(prevState => ({ ...prevState, loading: false }));
            } else {
                setState(prevState => ({ ...prevState, loading: false, error:true, errorMessage: error.message }));
            }
            throw error;
        })
    }, [setState, secureNetworkId]);

    return {
        data: state.data,
        loading: state.loading,
        error: state.error,
        errorMessage: state.errorMessage,
        refetch: fetchData,
        updateAPIData: setState
    };
}
